import React from 'react';
import { colors } from '@styles/core-styles/theme';

export const PrototypeIcon: React.FC<{
	color?: string;
	width?: string;
	height?: string;
}> = ({ color = colors.orange, width = '100%', height = '100%' }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 69 69"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M27.9998 23.7637L23.8857 27.8665L34.9801 55.3944L46.7939 59.6096L59.7317 46.6718L55.5165 34.858L27.9998 23.7637Z"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M46.7935 59.6097L59.7313 46.6719L67.9256 50.1902L50.3117 67.804L46.7935 59.6097Z"
				fill={color}
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M23.8408 16.3108C34.8565 8.50994 49.8176 8.71227 60.631 16.9291"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M17.1187 60.7228C8.80069 49.9432 8.53092 34.9596 16.2869 23.8877"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M44.9954 50.1109C47.8883 50.1109 50.2335 47.7657 50.2335 44.8728C50.2335 41.9799 47.8883 39.6348 44.9954 39.6348C42.1025 39.6348 39.7573 41.9799 39.7573 44.8728C39.7573 47.7657 42.1025 50.1109 44.9954 50.1109Z"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M19.8279 24.9322C22.7208 24.9322 25.066 22.587 25.066 19.6941C25.066 16.8012 22.7208 14.4561 19.8279 14.4561C16.935 14.4561 14.5898 16.8012 14.5898 19.6941C14.5898 22.587 16.935 24.9322 19.8279 24.9322Z"
				fill={color}
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M3.39423 38.5219C4.71652 38.5219 5.78845 37.4499 5.78845 36.1276C5.78845 34.8053 4.71652 33.7334 3.39423 33.7334C2.07193 33.7334 1 34.8053 1 36.1276C1 37.4499 2.07193 38.5219 3.39423 38.5219Z"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M36.2053 5.7113C37.5276 5.7113 38.5995 4.63937 38.5995 3.31708C38.5995 1.99478 37.5276 0.922852 36.2053 0.922852C34.883 0.922852 33.811 1.99478 33.811 3.31708C33.811 4.63937 34.883 5.7113 36.2053 5.7113Z"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M16.0733 23.3477L5.08008 34.3296"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M34.4629 4.95801L23.4697 15.9512"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M62.9744 14.864L58.5552 19.2832L62.9744 23.7024L67.3936 19.2832L62.9744 14.864Z"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M17.1301 60.7225L14.7358 63.1167L19.1534 67.5342L23.5709 63.1167L19.1534 58.6992L17.1301 60.7225Z"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M25.9424 25.8203L41.2969 41.1748"
				stroke={color}
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};
